import { render, staticRenderFns } from "./AssureursParent.vue?vue&type=template&id=28197e50&"
import script from "./AssureursParent.vue?vue&type=script&lang=js&"
export * from "./AssureursParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports